import type { ApiClient } from './client.js';
import type { InitialPairingApi } from '../device-ble/initial-provision.js';

/** Use the existing authenticated, generation-checked client for every request. */
export function initialPairingApi(api: ApiClient): InitialPairingApi {
  return {
    initialPairingStart: (id, body, signal) => api.request('POST', `/api/devices/${encodeURIComponent(id)}/initial-pairing/start`, body, { signal, op: 'initial-pairing.start' }),
    screenPairingStart: (id, body, signal) => api.request('POST', `/api/devices/${encodeURIComponent(id)}/screen-pairing/start`, body, { signal, op: 'screen-pairing.start' }),
    initialPairingFinish: (id, body, signal) => api.request('POST', `/api/devices/${encodeURIComponent(id)}/initial-pairing/finish`, body, { signal, op: 'initial-pairing.finish' }),
    initialPairingCancel: (id, body, signal) => api.request('POST', `/api/devices/${encodeURIComponent(id)}/initial-pairing/cancel`, body, { signal, op: 'initial-pairing.cancel' }),
    listDevices: signal => api.listDevices(signal),
  };
}
